import './index.css';

import { createRoot } from 'react-dom/client';

import App from './App';
import AppConfiguration from './AppConfiguration';
import { getAppParameters } from './AppParameters';
import { configureEasyClaimEnv } from './easyclaim.app.configuration/env';
import { SentryService } from './easyclaim.app.services/index';

const configUrl = `${window.location.origin}/config.json`;

await fetch(configUrl)
	.then((response) => response.json() as unknown as AppConfiguration)
	.then((appConfiguration) => {
		new SentryService(appConfiguration.sentry).registerOnErrorHandler();

		appConfiguration.easyClaimBackend.basePath = window.origin.includes('localhost')
			? appConfiguration.easyClaimBackend.basePath
			: window.origin;

		const apiBasePath = process.env.REACT_APP_CIAPI_BASE_PATH?.trim();

		if (apiBasePath) {
			appConfiguration.easyClaimBackend.basePath = apiBasePath;
		}

		configureEasyClaimEnv(appConfiguration.easyClaimBackend);

		const appParams = getAppParameters();

		document.documentElement.setAttribute('lang', appParams.lang);
		const container = document.getElementById('root')!;

		createRoot(container).render(
			<App appConfiguration={appConfiguration} appParameters={appParams} />
		);
	});
